import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  text-align: left;
  display: grid;
  grid-template-columns: 98px 1fr;
  grid-template-rows: 72px 1fr;
  align-items: center;

  @media (max-width: 1630px) {
    grid-template-columns: 90px 1fr;
  }
  @media (max-width: 1500px) {
    grid-template-columns: 85px 1fr;
  }
  @media (max-width: 1405px) {
    grid-template-columns: 75px 1fr;
  }
  @media (max-width: 1150px) {
    display: block;
    text-align: center;
    margin: 0 auto;
    grid-column: ${props => (props.bottomContainer ? "1/3" : "")};
    max-width: ${props => (props.bottomContainer ? "358px" : "264px")};
  }
  @media (max-width: 630px) {
    margin-bottom: 56px;
  }
`;

const ImageContainer = styled.div`
  width: 55px;
  height: 55px;
  border-radius: 0px 0px 0px 25px;
  background-color: ${props => props.backgroundImageColor};
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1150px) {
    margin: 0 auto;
    width: 60px;
    height: 60px;
  }
`;

const Image = styled.img`
  filter: drop-shadow(0px 10px 10px rgba(251, 212, 152, 0.5));
`;

const TextContainer = styled.div`
  font-size: 18px;
  line-height: 1.9;
  color: #777984;
  align-self: flex-start;

  @media (max-width: 1820px) {
    font-size: 16px;
    line-height: 1.8;
  }
  @media (max-width: 1330px) {
    font-size: 15px;
  }
  @media (max-width: 1200px) {
    font-size: 14px;
  }
  @media (max-width: 1150px) {
    font-size: 16px;
  }
`;

const TextHeader = styled.div`
  font-size: 21px;
  font-weight: bold;
  color: #1f2021;

  @media (max-width: 1870px) {
    font-size: 20px;
  }
  @media (max-width: 1810px) {
    font-size: 19px;
  }
  @media (max-width: 1500px) {
    font-size: 18px;
  }
  @media (max-width: 1330px) {
    font-size: 17px;
  }
  @media (max-width: 1150px) {
    font-size: 24px;
    margin-top: 29px;
    margin-bottom: 22px;
  }
  @media (max-width: 630px) {
    margin-top: 42px;
    margin-bottom: 26px;
  }
`;

const HowWeCanHelpItem = ({
  header,
  text,
  image,
  bottomContainer,
  backgroundImageColor,
  itemId
}) => (
  <Container
    bottomContainer={bottomContainer}
    className={`how-we-can-help-main how-we-can-help-mobile${itemId} `}
  >
    <ImageContainer backgroundImageColor={backgroundImageColor}>
      <Image src={image} alt="icon" />
    </ImageContainer>
    <TextHeader>{header}</TextHeader>
    <div />
    <TextContainer>{text}</TextContainer>
  </Container>
);

export default HowWeCanHelpItem;
